var _path, _path2, _rect, _g, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneralInsurance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    width: 96,
    height: 96,
    role: "img",
    "aria-label": "General insurance",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "General insurance") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 44L42 26l22 18v26a3 3 0 01-3 3H23a3 3 0 01-3-3z",
    fill: "#e0a82e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 46L42 24l26 22",
    fill: "none",
    stroke: "#c8932a",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 56,
    width: 12,
    height: 17,
    fill: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30 78l3-9a3 3 0 013-2h14a3 3 0 013 2l3 9v8a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2H36v2a2 2 0 01-2 2h-2a2 2 0 01-2-2z",
    fill: "#c8932a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 80,
    r: 2.5,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 80,
    r: 2.5,
    fill: "#ffffff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66 50l12 4v9c0 7-5 11-12 14-7-3-12-7-12-14v-9z",
    fill: "#e0a82e",
    stroke: "#c8932a",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61 64l4 4 7-8",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralInsurance);
export default __webpack_public_path__ + "static/media/general-insurance.5b129ff3afedb12009c5c5d19a5f3b91.svg";
export { ForwardRef as ReactComponent };